import dynamic from 'next/dynamic';
import { BlockProps } from '../BlockProps';
import { IMachinesSliderCoverBlockData } from './IMachinesSliderCoverBlockData';
import { TServerSideMachinesSliderCoverBlockProps } from './TServerSideMachinesSliderCoverBlockProps';

export const DynamicMachineSliderCoverBlock = dynamic<
    BlockProps<
        IMachinesSliderCoverBlockData,
        TServerSideMachinesSliderCoverBlockProps
    >
>(() =>
    import('./MachinesSliderCoverBlock').then(
        md => md.MachinesSliderCoverBlock,
    ),
);
